import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_DK_UQ || "uq.dk.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_DK_UQ || 24197,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_DK_UQ || 24198,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_DK_UQ ||
    "1:160978693362:web:5feb8d6f84b032eb47346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-TEL6Q5D83K" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN]
};

export default _countryEnv;
